// Database browser — schema tree view (Tiles=Databases, Hubs=Tables, Seeds=Records)
import { api } from './api.js';

let _connectionId = null;

export function setConnection(id) { _connectionId = id; }

export function init() {
  document.getElementById('btn-refresh-schema').addEventListener('click', () => loadSchema());
}

export async function loadSchema() {
  const container = document.getElementById('schema-tree-content');
  if (!_connectionId) {
    container.innerHTML = '<div class="tree-empty">Connect to a database to browse schema</div>';
    return;
  }

  container.innerHTML = '<div class="tree-empty">Loading...</div>';

  try {
    const res = await api.databases(_connectionId);
    if (!res.success || !res.data) {
      container.innerHTML = '<div class="tree-empty">' + (res.error || 'Failed to load') + '</div>';
      return;
    }

    const databases = res.data;
    if (!databases.length) {
      container.innerHTML = '<div class="tree-empty">No databases found</div>';
      return;
    }

    container.innerHTML = '';
    for (const db of databases) {
      const node = createDbNode(db);
      container.appendChild(node);
    }
  } catch (err) {
    container.innerHTML = '<div class="tree-empty">Error: ' + err.message + '</div>';
  }
}

function createDbNode(db) {
  const wrap = document.createElement('div');

  const node = document.createElement('div');
  node.className = 'tree-node';
  node.innerHTML = '<i class="fas fa-chevron-right"></i><i class="fas fa-database icon-db"></i><span>' + esc(db.name) + '</span>';
  if (db.rowCount != null) {
    node.innerHTML += '<span style="margin-left:auto;color:var(--text-dim);font-size:10px">' + db.rowCount + '</span>';
  }

  const children = document.createElement('div');
  children.className = 'tree-children collapsed';
  let loaded = false;

  node.addEventListener('click', async () => {
    const arrow = node.querySelector('.fa-chevron-right, .fa-chevron-down');
    const isOpen = !children.classList.contains('collapsed');
    if (isOpen) {
      children.classList.add('collapsed');
      arrow.classList.replace('fa-chevron-down', 'fa-chevron-right');
    } else {
      children.classList.remove('collapsed');
      arrow.classList.replace('fa-chevron-right', 'fa-chevron-down');
      if (!loaded) {
        loaded = true;
        await loadTables(db.name, children);
      }
    }
    showDetail('database', db);
  });

  wrap.appendChild(node);
  wrap.appendChild(children);
  return wrap;
}

async function loadTables(dbName, container) {
  container.innerHTML = '<div class="tree-node"><i class="fas fa-spinner fa-spin" style="width:16px"></i><span style="color:var(--text-dim)">Loading...</span></div>';

  try {
    const res = await api.tables(_connectionId, dbName);
    container.innerHTML = '';
    if (!res.success || !res.data) {
      container.innerHTML = '<div class="tree-node"><span style="color:var(--text-dim)">Empty</span></div>';
      return;
    }

    for (const col of res.data) {
      const colNode = document.createElement('div');
      colNode.className = 'tree-node';
      const typeStr = col.type ? ' <span style="color:var(--text-dim);font-size:10px">' + col.type + '</span>' : '';
      const nullable = col.nullable ? ' <span style="color:var(--text-dim);font-size:10px">NULL</span>' : '';
      colNode.innerHTML = '<i class="fas fa-table icon-table"></i><span>' + esc(col.name) + '</span>' + typeStr + nullable;
      colNode.addEventListener('click', (e) => {
        e.stopPropagation();
        document.querySelectorAll('.tree-node.active').forEach(n => n.classList.remove('active'));
        colNode.classList.add('active');
        showDetail('table', { database: dbName, ...col });
      });
      container.appendChild(colNode);
    }
  } catch {
    container.innerHTML = '<div class="tree-node"><span style="color:var(--error)">Failed</span></div>';
  }
}

function showDetail(type, data) {
  const detail = document.getElementById('browser-detail-content');

  if (type === 'database') {
    detail.innerHTML = `
      <div class="detail-header">
        <div class="detail-type"><i class="fas fa-database"></i> Database</div>
        <h3>${esc(data.name)}</h3>
      </div>
      <table class="detail-table">
        <tr><th>Property</th><th>Value</th></tr>
        <tr><td>Name</td><td>${esc(data.name)}</td></tr>
        ${data.rowCount != null ? '<tr><td>Tables</td><td>' + data.rowCount + '</td></tr>' : ''}
      </table>
    `;
  } else if (type === 'table') {
    detail.innerHTML = `
      <div class="detail-header">
        <div class="detail-type"><i class="fas fa-table"></i> Table</div>
        <h3>${esc(data.database)} / ${esc(data.name)}</h3>
      </div>
      <table class="detail-table">
        <tr><th>Property</th><th>Value</th></tr>
        <tr><td>Name</td><td>${esc(data.name)}</td></tr>
        <tr><td>Database</td><td>${esc(data.database)}</td></tr>
        ${data.type ? '<tr><td>Type</td><td>' + esc(data.type) + '</td></tr>' : ''}
      </table>
    `;
  }
}

function esc(s) {
  return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
